/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerUpRightIcon16Light = forwardRef('ArrowDCornerUpRightIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M9.854 1.646a.5.5 0 1 0-.708.708L12.793 6H4.5A2.5 2.5 0 0 0 2 8.5v6a.5.5 0 0 0 1 0v-6A1.5 1.5 0 0 1 4.5 7h8.293l-3.647 3.646a.5.5 0 0 0 .708.708l3.651-3.652a1.7 1.7 0 0 0 0-2.404L9.854 1.646Z" })));
});
